module.exports = __webpack_public_path__ + "static/better-employee-charlie-800w-1cebc5b1290cde1bcacfc88e4d5dc2ad.jpg";